import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { ResourceNotFoundComponent } from './modules/errors/resource-not-found/resource-not-found.component';
import { initialDataResolver } from './app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'fidelity-app' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'registration',
    },

    // Auth routes for fidelity app users
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        data: {
            layout: 'fidelity-app',
        },
        children: [
            {
                path: 'fidelity-app',
                loadChildren: () => import('app/modules/fidelity-app/fidelity-app.routes'),
            },
        ],
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'registration',
                loadChildren: () => import('app/modules/landing/customer-registration/customer-registration.routes'),
            },
            {
                path: 'survey',
                loadChildren: () => import('app/modules/landing/survey/survey.routes'),
            },
            {
                path: 'registration-confirmation',
                loadChildren: () =>
                    import('app/modules/landing/registration-confirmation/registration-confirmation.routes'),
            },
            {
                path: 'reset-password',
                loadChildren: () => import('app/modules/landing/reset-password/reset-password.routes'),
            },
            //wildcard route for inaccessible resources.
            { path: '**', component: ResourceNotFoundComponent },
        ],
    },
];
